import { Fragment, memo } from 'react';
import { cn } from '@divlab/divanui';

import styles from './Dimension.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface Value {
  name: string;
  value: string;
}

export interface DimensionProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  name: string;
  value: Value[];
}

const Dimension: FC<DimensionProps> = (props) => {
  const { className, name, value, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.dimension, className)}>
      <span className={styles.name}>{`${name}: `}</span>
      {value.map((item: Value, index) => {
        const isLast = index + 1 === value.length;

        return (
          <Fragment key={`${name}_${index}`}>
            <span>{`${item.name} ${item.value}`}</span>
            {!isLast && <span className={styles.delimiter}>х</span>}
          </Fragment>
        );
      })}
    </div>
  );
};

export default memo(Dimension);
